import GenericDB from './generic-db';

export default class SessionNoteFieldsDB extends GenericDB {
  constructor() {
    super('sessionNoteFields');
  }
}
